import * as fn from './utils'
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {useState, useEffect} from 'react'
import SendIcon from '@mui/icons-material/Send';
import AddIcon from '@mui/icons-material/Add';
import {db, storage} from './firebase'
import {deleteDoc, doc} from 'firebase/firestore'
import {getDownloadURL, ref, uploadBytes} from 'firebase/storage'
import {FormProvider} from './Context';
import useForm from './useForm';

export function ImagePost(props:any){

    const [image, setImage] = useState('')

        async function getImage(){
        const new_img = await getDownloadURL(ref(storage,'posts/'+props.imageURL))
        setImage(new_img)
    }
    useEffect(()=>{
        getImage()
    },[])

    return(
        <div style={{backgroundImage:`url(`+image+`)`, width:'300px', height:'300px', backgroundSize:'cover'}}/>
    )
}

function DummyDate(daysOffset: number): string {
    const date = new Date();

    date.setDate(date.getDate() - daysOffset);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

export function Post(props:any){

    const {setPostData, postData}:any = useForm()
    const {reload, setReload}:any = useForm()

    const post = props.post
    const [readMore, setReadMore] = useState(false)
    const [deletePost, setDeletePost] = useState(false)

    async function goDeletePost(docId:string){
        await deleteDoc(doc(db, 'blog', docId))
        .then(()=>{
            setReload(true)
        })
}


    return(
        <div style={{backgroundColor:props.access==0&&(fn.Colors.background)||(fn.Colors.pastelLight), display:'flex', width:props.mobile?'95%':'60%', justifyContent:'center', alignItems:readMore?props.mobile?'center':'start':'center', marginTop:'20px', borderRadius:'10px', padding:'20px 0', flexDirection:props.mobile&&('column')}}>
                                {props.mobile&&(
                                    <div style={{fontWeight:'600', fontFamily:fn.Fonts.subtitle, fontSize:'35px', width:'90%'}}>
                                        {post.title}
                                    </div>
                                )}
                                {props.mobile&&(
                                    <div style={{fontWeight:'600', fontSize:'12px', color:fn.Colors.foreground, width:'90%'}}>
                                            {/* escrito por Stephanie Faria em {post.date} */}
                                            escrito por Stephanie Faria em {DummyDate((props.index+1)*17)}
                                    </div>
                                )}
                                <div style={{boxSizing:'border-box', display:'flex', justifyContent:'center',alignItems:'center', margin:props.mobile?'10px 0':''}}>
                                    <div style={{display:'flex',justifyContent:'left', alignItems:'center'}}>
                                        <ImagePost imageURL={`${post.doc_id}.${post.image.split('.').pop()}`} mobile={props.mobile}/>
                                    </div>
                                </div>
                                <div style={{width:props.mobile?'95%':'50%', display:'flex',justifyContent:'left', flexDirection:'column',paddingLeft:!props.mobile?'40px':'', boxSizing:'border-box'}}>
                                    {!props.mobile&&(
                                        <div style={{fontWeight:'600', fontFamily:fn.Fonts.subtitle, fontSize:'35px'}}>
                                            {post.title}
                                        </div>
                                    )}
                                    {!props.mobile&&(
                                        <div style={{fontWeight:'600', fontSize:'12px', color:fn.Colors.foreground}}>
                                            escrito por Stephanie Faria em {DummyDate((props.index+1)*17)}
                                        </div>
                                    )}
                                    <div style={{margin:'10px 0', whiteSpace:'pre-wrap'}}>
                                        {readMore&&(post.text)||(
                                            post.text.slice(0,150)
                                        )}
                                        {!readMore&&post.text.length>80&&('...')}
                                    </div>
                                    {post.text.length>150&&!readMore&&(
                                        <div style={{color:fn.Colors.light, fontWeight:'500', textDecoration:'underline'}}>
                                            <span style={{cursor:'pointer'}} onClick={()=>{setReadMore(true)}}>Ler mais</span>
                                        </div>
                                    )}
                                    {readMore&&(
                                        <div style={{color:fn.Colors.light, fontWeight:'500', textDecoration:'underline'}}>
                                            <span style={{cursor:'pointer'}} onClick={()=>{setReadMore(false)}}>Ler menos</span>
                                        </div>
                                    )}
                                    {props.access==1&&(
                                        <div style={{display:'flex', justifyContent:'right'}}>
                                            <EditIcon style={{scale:'1.4', cursor:'pointer'}} onClick={()=>{setPostData(post)}}/>
                                            {deletePost&&(
                                                <div style={{display:'flex', flexDirection:'column', fontSize:'9px', fontWeight:'600', alignItems:'center', marginLeft:'15px', border:'1px solid #000', borderRadius:'5px', padding:'3px'}}>
                                                    <div>
                                                        Deletar post?
                                                    </div>
                                                    <div style={{display:'flex'}}>
                                                        <div style={{cursor:'pointer'}} onClick={()=>{goDeletePost(post.doc_id)}}>
                                                            SIM
                                                        </div>
                                                        <div style={{cursor:'pointer', marginLeft:'10px'}} onClick={()=>{setDeletePost(false)}}>
                                                            NÃO
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {!deletePost&&(<DeleteForeverIcon style={{scale:'1.4', marginLeft:'15px', cursor:'pointer'}} onClick={()=>{setDeletePost(true)}}/>)}
                                        </div>
                                    )}
                                </div>
                        </div>
    )
}

export function Blog(props:any){

    const [posts, setPosts] = useState([])
    const {reload, setReload}:any = useForm()

    async function getPosts(){
        // const docRef = collection(db, 'blog')
        // const snapshot = await getDocs(docRef)
        // let posts_var:any = []
        // snapshot.forEach((doc)=>{
        //     posts_var.push({
        //         title:doc.data().title,
        //         text: doc.data().text,
        //         date: doc.data().date,
        //         image: doc.data().image,
        //         timestamp: fn.dateStringToTimestamp(doc.data().date),
        //         doc_id: doc.id
        //     })
        // })
        const docs = await fn.getDocs('blog')
        let posts_var:any = []
        for(let a=0;a<docs.length;a++){
            posts_var.push({
                title:docs[a].data.title,
                text:docs[a].data.text,
                date:docs[a].data.date,
                image:docs[a].data.image,
                timestamp:fn.dateStringToTimestamp(docs[a].data.date),
                doc_id: docs[a].id
            })
        }
        setPosts(posts_var.sort(((a:any,b:any)=>b.timestamp-a.timestamp)))
    }

    useEffect(()=>{
        if(posts.length==0){
            getPosts()
        }
    },[])

    useEffect(()=>{
        if(reload){
            getPosts()
        }
    },[reload])

    return(
        <div style={{width:"100%", display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center', paddingBottom:'50px'}}>
            {posts.map((post:any, index:any)=>{
                return(
                        <Post key={index} index={index} post={post} access={props.access} mobile={props.mobile}/>
                    )
            })}
        </div>
    )
}